module.exports = __webpack_public_path__ + "media/images/lorry-cf28d41c8478e3063e41a653dcd71a75.png";